<script setup lang="ts">
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";
import router from "@/router";

const { t } = useI18n();

function openMainPage() {
  router.push({ name: ROUTE_NAMES.HOME });
}
</script>

<template>
  <div
    class="flex items-center xl:justify-center gap-3 xl:mx-auto h-full cursor-pointer"
    @click="openMainPage"
  >
    <img
      src="@/assets/logo.svg"
      alt="Лого"
      class="xl:w-16 xl:h-16 w-[46px] h-[46px]"
    />
    <div class="flex flex-col leading-tight text-left">
      <span class="font-caudex xl:text-[27px] text-[16px]">Fengshui Style</span>
      <span class="xl:sf-pro-xs sf-pro-400-8 text-muted text-left">
        {{ t("feng_shui_tools") }}
      </span>
    </div>
  </div>
</template>
